import type { FieldConfig, BuiltinFieldType } from "./FormBuilder";
import type { FieldValues, Path } from "react-hook-form";

export function createField<TForm extends FieldValues, TType extends BuiltinFieldType = "text">(
  name: Path<TForm>,
  type: TType,
  config?: Omit<FieldConfig<TForm>, 'name' | 'type'>
): FieldConfig<TForm> {
  return {
    name,
    type,
    ...config
  };
}